import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom'
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { Alert } from '../../services/Alert';

import { useAuth } from '../../auth/useAuth';
import { Funciones } from '../../services/Funciones';
import DatePicker from 'react-datepicker';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const PriceIdPage = () => {

    const auth = useAuth();
    const fun = Funciones();
    const history = useHistory();
    
    //Parametros por url
    const { folio } = useParams();
    
    const [state, setstate] = useState({
        cotizacion: {
            folio:'',
            productos:[]
        },
        folio: folio,
        folio_lista: '',
        mensaje: '',
        cargado: false,
        config: JSON.parse(localStorage.getItem('config'))
    })

    const [productos, setproductos] = useState([])
    const [startDate, setStartDate] = useState(new Date());
    const [file, setfile] = useState(null);

    const loadCotizacion = () => {
        
        const getData = async() => {
            const config = JSON.parse(localStorage.getItem('config'));
            const BaseUrl = config.baseUrl || 'http://localhost/wservices/';
            const AppId = config.appId ||'';

            if(AppId===''){
                return;
            }
            
            try{
                //console.log(state);
                const data = {
                    apikey: AppId || '',
                    action: 'GetCotizacionId',
                    provider: 'proveedor',
                    data: {
                        usuario: auth.user.usuario,
                        tabla: auth.user.tabla,
                        clave: auth.user.clave,
                        folio: state.folio
                    }
                }
                
                await axios.post(BaseUrl, data)
                .then(response => {
                    return response.data
                })
                .then(datos => {
                    
                    if((datos.type || '') === ''){
                        Alert('Advertencia: No hubo respuesta del servidor','warning',{});
                        return;
                    }
                    
                    //Ya tenemos una respuesta valida, ahora la procesamos
                    if(datos.type === 'error'){
                        Alert('Advertencia: '+ datos.code + ' - ' + datos.message,'warning',{});
                        return;
                    }
                    
                    const resultado = datos.data || {};
                    
                    let cotizacionobj = resultado.cotizacion || [];
                    
                    setproductos(cotizacionobj.productos || []);

                    setstate({
                        ...state, 
                        cotizacion: cotizacionobj, 
                        mensaje: resultado.mensaje || '', 
                        cargado: true, 
                        config: config 
                    });
                    
                }).catch(error => {
                    Alert('Error: '+error.message,'error',{});
                });
            }catch(error){
                Alert('Error: '+error.message,'error',{});
            }
        }

        getData();
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const getData = async() => {
            const config = JSON.parse(localStorage.getItem('config'));
            const BaseUrl = config.baseUrl || 'http://localhost/wservices/';
            const AppId = config.appId ||'';

            if(AppId===''){
                Alert('Advertencia: No se encontro el appid para conectar a la base de datos','warning',{});
                return;
            }
            
            try{
                let showError = false;
                let msgError = "";
                //Primero validamos que tengan configurado un precio correcto
                productos.forEach(element => {
                    if(parseFloat(element.precio) < 0 && !showError){
                        msgError = 'Advertencia: El producto ' + element.descripcion + ', no tiene un precio valido';
                        showError = true;
                    }
                });

                if(showError){
                    Alert(msgError,'warning',{});
                    return;
                }

                //console.log(state);
                const data = {
                    apikey: AppId || '',
                    action: 'SetCotizacionPrecio',
                    provider: 'proveedor',
                    data: {
                        usuario: auth.user.usuario,
                        tabla: auth.user.tabla,
                        clave: auth.user.clave,
                        folio: state.folio,
                        fecha: fun.getDMY(startDate,'/'),
                        productos: productos
                    }
                }
                
                await axios.post(BaseUrl, data)
                .then(response => {
                    return response.data
                })
                .then(datos => {
                    
                    if((datos.type || '') === ''){
                        Alert('Advertencia: No hubo respuesta del servidor','warning',{});
                        return;
                    }
                    
                    //Ya tenemos una respuesta valida, ahora la procesamos
                    if(datos.type === 'error'){
                        Alert('Advertencia: '+ datos.code + ' - ' + datos.message,'warning',{});
                        return;
                    }
                    
                    const resultado = datos.data || {};
                    
                    let documento = resultado.documento || [];
                    
                    setstate({
                        ...state, 
                        mensaje: resultado.mensaje || '', 
                        cargado: true, 
                        config: config, 
                        folio: documento.folio,
                        folio_lista: documento.folio_lista
                    });
                    
                    Alert('Información: Precios actualizados, folio: '+ documento.folio_lista,'info',{});
                }).catch(error => {
                    Alert('Error: '+error.message,'error',{});
                });
            }catch(error){
                Alert('Error: '+error.message,'error',{});
            }
        }

        getData();
    }

    const handleChange = (e) => {
        e.preventDefault();

        let valor = e.target.value;
        let name = e.target.name.replace("row_","")
        let tmpProductos = productos;

        tmpProductos.forEach(row => {
            if(row.id===name){
                row.precio = parseFloat(valor);
            }
        })

        setproductos(tmpProductos);
    }

    const handleChangeFecha = (date) => {
        setStartDate(date);
        //console.log(date);
    }

    const exportToCSV = () => {
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        const ws = XLSX.utils.json_to_sheet(productos);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, 'CotizacionPrecio' + fileExtension);
    }
    
    const filePathset = (e) => {
        e.stopPropagation();
        e.preventDefault();
        var file = e.target.files[0];
        readFile(e.target.files[0]);
    }

    const readFile = (f) => {
        if(f===undefined||f===null){
            setfile(null);
            return;
        }
        
        const reader = new FileReader();
        reader.onload = (evt) => {
          const bstr = evt.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
          const finalFile = convertToJson(data);
          setfile(finalFile);
          //console.log(finalFile);
        };
        reader.readAsBinaryString(f);
    }

    const convertToJson = (csv) => {
        var lines = csv.split("\n");
        var result = [];
        var headers = lines[0].split(",");
    
        for (var i = 1; i < lines.length; i++) {
          var obj = {};
          var currentline = lines[i].split(",");
        
          if(currentline[0]!==''){
              for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
              }
              result.push(obj);
          }
        }
        
        return result; //JavaScript object
        //return JSON.stringify(result); //JSON
    }

    const loadImportCSV = () => {
        if(file===null){
            Alert('Advertencia: No se ha cargado archivo para importar','warning',{});
            return;
        }

        //Cargamos los datos que se importaron
        setstate({...state,cotizacion:{...state.cotizacion, productos: file }});
        setproductos(file);
        
        Alert('Información: Archivo cargado con exito','info',{});
    }
    
    useEffect(() => {
        if(!state.cargado){
            if(state.folio===''){
                history.push('/price/');
            }
            loadCotizacion();
        }
    }, [])

    return (
        <div className="container mt-5 mb-5">
            <div className='row'>
                <h1 className='m8-h2 animated fadeIn'>Cotizacion</h1>
                <h6 className='m8-h4 animated fadeIn'>{ 'Folio: ' + state.folio }</h6>
            </div>
            { state.mensaje !== '' ? (
                <div className='row'>
                    <div className="mb-3 mt-3">
                        { state.mensaje }
                    </div>
                </div>
            ) : '' }
            <div className="mb-3">
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 m8-text">
                        <b>Fecha:</b> { state.cotizacion.fecha || fun.getDate() }<br />
                        <b>Vencimiento:</b> { state.cotizacion.vencimiento || fun.getDate() }<br />
                        <b>Sucursal:</b> { state.cotizacion.sucursal || '' }<br />
                        <b>Comprador:</b> { state.cotizacion.comprador || '' }<br />
                        <b>Comentario:</b> { state.cotizacion.comentario || '' }
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <div className='row'>
                            <div className="col-12 col-sm-6 col-md-6">
                                <b className="m8-ilabel">Vigencia de precios:</b>
                                <DatePicker dateFormat="yyyy/MM/dd" selected={startDate} onChange={ (date) => handleChangeFecha(date) } className='form-control m8-itext mb-3' />
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                            <b className="m8-ilabel">Cargar archivo XLSX:</b>
                                <input type="file" id="file" onChange={filePathset.bind(this)} placeholder='...' className='form-control mb-2 m8-itext'/>
                                <a className='upload btn btn-sm m8-btn-b1 ps-3 pe-3 me-3' href="#" onClick={ ()=> exportToCSV() }>Descargar lista</a>
                                <button className='btn btn-sm m8-btn-submit ps-3 pe-3' onClick={() => { loadImportCSV(); }} >Cargar</button>
                                <a id="downlink"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <form name="formPriceId" onSubmit={ (e) => e.preventDefault() }>
                <div className="mb-3 mt-3">
                    <div className="table-responsive">
                        <table className="table table-bordered table-sm m8-table">
                            <thead>
                                <tr className="text-center">
                                    <th>#</th>
                                    <th>Clave</th>
                                    <th>Talla</th>
                                    <th>Color</th>
                                    <th>Descripcion</th>
                                    <th>Unidad</th>
                                    <th>Cantidad</th>
                                    <th>Precio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.cotizacion.productos.map(row => (
                                    <tr className="" key={row.id}>
                                        <td align="center">{ row.id }</td>
                                        <td align="center">{ row.clave }</td>
                                        <td align="center">{ row.talla }</td>
                                        <td align="center">{ row.color }</td>
                                        <td align="left">{ row.descripcion }</td>
                                        <td align="center">{ row.unidad }</td>
                                        <td align="right">{ fun.toNumber(row.cantidad,0) }</td>
                                        <td align="right" className="text-end" style={{ width: '120px' }}>
                                        <div className="input-group input-group-sm" style={{ width: '120px' }}>
                                            <div className="input-group-prepend">
                                                <div className="input-group-text m8-ilabel" style={{ backgroundColor: 'inherit', border:0 }}>$</div>
                                            </div>
                                            <input className="form-control from-control-sm m8-itext" id={ "row_" + row.id.toString() } name={"row_" + row.id.toString() } onChange={ handleChange } type="number" value={ fun.toNumber(row.precio,2) }/>
                                        </div>
                                        </td>
                                    </tr>
                                    ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="8">Total: { state.cotizacion.productos.length }</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className="mb-3 mt-3 text-center">
                    <button className="btn btn-sm m8-btn-submit ps-3 pe-3" type="button" onClick={ handleSubmit }>Actualizar precios</button>
                </div>
                
            </form>
            <ToastContainer />
        </div>
    )
}
